import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function SustainabilityHero() {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!root.current) return;
    const ctx = gsap.context(() => {
      gsap.from(".sus-hero-word", {
        yPercent: 100,
        opacity: 0,
        duration: 1,
        stagger: 0.06,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 75%" },
      });
      gsap.from(".sus-hero-body", {
        y: 40,
        opacity: 0,
        duration: 1,
        delay: 0.3,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 75%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  const line1 = "Repair,".split(" ");
  const line2 = "rewear,".split(" ");
  const line3 = "rewild.".split(" ");

  return (
    <section
      ref={root}
      className="relative bg-forest text-bone pt-32 md:pt-40 pb-20 md:pb-28 px-6 md:px-10 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(245,241,234,0.6) 1px, transparent 0)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative max-w-5xl mx-auto text-center">
        <p className="text-[11px] font-mono uppercase tracking-[0.22em] text-clay mb-6">
          ✦ Our commitment
        </p>
        <h1 className="font-display tracking-tightest leading-[0.92] font-light text-5xl md:text-7xl lg:text-[100px]">
          <span className="block overflow-hidden">
            {line1.map((w, i) => (
              <span key={i} className="inline-block overflow-hidden">
                <span className="sus-hero-word inline-block mr-3">{w}</span>
              </span>
            ))}
          </span>
          <span className="block overflow-hidden font-display text-clay">
            {line2.map((w, i) => (
              <span key={i} className="inline-block overflow-hidden">
                <span className="sus-hero-word inline-block mr-3">{w}</span>
              </span>
            ))}
          </span>
          <span className="block overflow-hidden">
            {line3.map((w, i) => (
              <span key={i} className="inline-block overflow-hidden">
                <span className="sus-hero-word inline-block">{w}</span>
              </span>
            ))}
          </span>
        </h1>
        <p className="sus-hero-body mt-10 text-bone/70 text-base md:text-lg leading-relaxed max-w-2xl mx-auto font-light">
          Sustainability is not a section of our website. It is the only way we know how to make clothes.
          Every decision — from fiber to factory to your closet — is measured against one question: does this heal more than it harms?
        </p>
      </div>
    </section>
  );
}